import { Controller } from '@hotwired/stimulus';

export default class DistanceUnitControlller extends Controller {
  declare private readonly inputTarget: HTMLInputElement;
  declare private readonly selectTarget: HTMLSelectElement;
  declare private readonly incrementTarget: HTMLElement;
  declare private readonly decrementTarget: HTMLElement;

  public static readonly targets = [
    'input',
    'select',
    'increment',
    'decrement'
  ];

  // TODO: It would be good to pass this in from the backend data relating
  // to distance units
  public static readonly distanceUnitData: Record<
    string,
    { abbreviation: string; step: string; incrementStep: string } | undefined
  > = {
    km: { abbreviation: 'km', step: '.01', incrementStep: '0.25' },
    mi: { abbreviation: 'mi', step: '.01', incrementStep: '0.25' },
    steps: { abbreviation: 'steps', step: '1', incrementStep: '1000' }
  };

  public connect(): void {
    this.selectTarget.addEventListener('change', () =>
      this.changeUnit({ reset: true })
    );

    this.changeUnit({ reset: false });
  }

  public changeUnit({ reset = true }: { reset: boolean }): void {
    const selectedUnit = this.selectTarget.value;
    const unitData = DistanceUnitControlller.distanceUnitData[selectedUnit];

    if (!unitData) {
      return;
    }

    this.incrementTarget.textContent = `+ ${unitData.incrementStep} ${unitData.abbreviation}`;
    this.decrementTarget.textContent = `- ${unitData.incrementStep} ${unitData.abbreviation}`;

    if (reset) {
      this.inputTarget.value = '0';
    }

    this.inputTarget.step = unitData.step;
    this.inputTarget.setAttribute(
      'list',
      `progress_update_${unitData.abbreviation}_distance_options`
    );
    this.element
      .querySelector('[data-incrementing-input-step-value]')
      ?.setAttribute(
        'data-incrementing-input-step-value',
        unitData.incrementStep.toString()
      );
  }
}
